import React from 'react'
// libs
import { reduxForm, submit } from 'redux-form'
// themes
import { colors } from 'themes'
// utils
import { lighten } from 'polished'
import { isColorLight } from 'utils/tree'

const withAddForm = (EnhancedComponent) => {
  const EnhancedWithAddForm = (props) => {
    const { level, onClose, form } = props

    const isRendered = React.useRef(false)

    React.useEffect(() => {
      isRendered.current = true
    }, [])

    const buttonProps = {
      textColor: isColorLight(level.color) ? colors.gray850 : colors.white,
      bg: level.color,
      hoveredBg: lighten(0.1, level.color)
    }

    const handleClose = () => {
      if (onClose) {
        onClose()
      }
    }

    const handleInputBlur = ({ input: { value }, meta: { dispatch } }) => {
      if (value) {
        dispatch(submit(form))
      } else {
        if (isRendered.current) {
          handleClose()
        }
      }
    }

    return (
      <EnhancedComponent
        {...props}
        handleInputBlur={handleInputBlur}
        buttonProps={buttonProps}
        handleClose={handleClose}
      />
    )
  }

  EnhancedWithAddForm.getInitialProps = async (props) => {
    let childProps = {}

    if (EnhancedComponent.getInitialProps) childProps = await EnhancedComponent.getInitialProps(props)

    return childProps
  }

  return reduxForm<any, any>({
    enableReinitialize: true,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true
  })(EnhancedWithAddForm)
}

export default withAddForm
